/** Назва власного гліфа іконки сторінки «Візуальна модель закону» (PageIcon малює його замість іконки Lucide). */
export const LAW_MODEL_ICON = 'law-model';
